export const dataHooks = {
  socialPostPreviewCaption: 'socialPostPreview-caption',
  socialPostPreviewMedia: 'socialPostPreview-media',
  socialPostPreviewProfileName: 'socialPostPreview-profileName',
  socialPostPreviewProfileImage: 'socialPostPreview-profileImage',
};

export const PUBLISH_DATE_JUST_NOW = 'Just now';
